<template>
    <v-container fluid grid-list-md>
        <containers></containers>
    </v-container>
</template>
<script>
import Containers from '../components/Containers/ContainerList.vue';

export default {
    components: {
        Containers
    }
};
</script>
